<template>
  <cookie-consent
    :message="cookieConsentMessage"
    :linkLabel="cookieConsentLinkLabel"
    :href="cookieConsentLink"
    aria-labelledby="cookie_consent_title"
  >
    <template #button>
      <button class="white --sm _mls">
        Accept Cookies
      </button>
    </template>
  </cookie-consent>
</template>

<script>
  import CookieConsent from 'vue-cookieconsent-component'

  export default {
    components: {
      CookieConsent
    },
    computed: {
      cookieConsentMessage() {
        return this.$store.state.cloudCannon.cloudCannonFooterContent
          .cookie_consent_message
      },
      cookieConsentLinkLabel() {
        return this.$store.state.cloudCannon.cloudCannonFooterContent
          .privacy_policy.privacy_policy_label
      },
      cookieConsentLink() {
        return this.$store.state.cloudCannon.cloudCannonFooterContent
          .privacy_policy.privacy_policy_url
      }
    }
  }
</script>

<style lang="scss">
.cookie-consent {
  background-color: $color_moon_bg;
  z-index: 999;
  color: white;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 50px;
  line-height: 1.25;
  .cookie-consent-link {
    color: #98EB89;
  }
  section {
    padding: 0px;
    overflow: inherit;
  }
}
</style>
